/**
 * Tipi di constraint gestiti dal motore dei constraint.
 * */
export enum ConstraintTypeEnum {
    Notification = 0,
    Filter = 1,
    Validation = 2,
    NormalValue = 3,
    Calculation = 4,
    CustomValue = 5,
    Disabler = 6,
}

/**
 * Operatore logico specificato in un constraint item.
 * Viene applicato al valore di una determinata colonna e ad un valore di confronto,
 * che può essere un valore fisso o il valore di un'altra colonna.
 * */
export enum LogicalOperatorEnum {
    IsNotNull = 0,
    IsNull = 1,
    Equals = 10,
    NotEquals = 11,
    GreaterThan = 13,
    GreaterOrEquals = 14,
    LessThan = 15,
    LessOrEquals = 16,
    //gli operatori di tipo stringa sono di default "ignore case".
    //eventualmente valutare se fare operatori analoghi "case sensitive"
    StartsWith = 20,
    EndsWith = 21,
    Contains = 22,
    ContainedIn = 23,
    LenEquals = 40,
    LenNotEquals = 41,
    LenGreaterThan = 42,
    LenGreaterOrEquals = 43,
    LenLessThan = 44,
    LenLessOrEquals = 45,

    //aggiungerci operazioni su array: contains_value per esempio
    //operazioni su array non booleane (ritornano un valore)
    GetFirstValueNotNull = 60,
    GetLastValueNotNull = 61,
    GetFirstValueEquals = 62,
    GetLastValueEquals = 63,
    GetFirstValueNotEquals = 64,
    GetLastValueNotEquals = 65,
    //per le proprietà di tipo stringa e array
    GetFirstValueContains = 70,
    GetLastValueContains = 71,
    GetFirstValueContainedIn = 72,
    GetLastValueContainedIn = 73,
}

/*
 * Enumerato che specifica su quali e quante entità effettuare la verifica del constraint item
 * */
export enum ConstraintItemCheckingModeEnum {
    /** Il constraint item deve essere valido almeno per una entity tra quelle della lista.*/
    AlmostOneEntity = 0,

    /** Il constraint item deve essere per la entity selezionata e che si sta editando*/
    OnlySelectedEntity = 1,

    /** Il constraint item deve essere valido per tutte le entity della lista*/
    AllEntities = 2,

    /** Il constraint item è verificato sulla lista delle entity*/
    EntityList = 3,
}
